import React from 'react';
import ReactPaginate from 'react-paginate';
import './pagination.scss'
import { Icons } from '../../assets';

export const Pagination = (props) => {
  const { pageMeta = {}, handlePageChange = {} } = props;
  return (
    <div className="flex justify-center pagination-wrapper mt-4 w-[550px]">  
      {pageMeta && pageMeta.totalPages > 1 ? (
        <ReactPaginate
          
          disableInitialCallback
          previousLabel={
            <div className='flex gap-4 items-center'>
            {/* <i className="icon-circle-left fs-25 fw-500" /> */}
            <img src={Icons.previousIcon} className='w-[24px] h-[24px]'/>
            <span className='labels'>Previous</span>
            </div>
          }
          nextLabel={
            <div className='flex gap-4 ml-[60px] items-center '>
          {/* <i className="icon-circle-right fs-25 fw-500" /> */}
          <span className='labels'>Next</span>
          <img src={Icons.nextIcon} className='w-[24px] h-[24px]'/>
            </div>
        }
          breakLabel={<span>...</span>}
          breakClassName="mx-2"
          pageCount={pageMeta.totalPages}
          pageRangeDisplayed={4}
          marginPagesDisplayed={0}
          onPageChange={(e) => handlePageChange(e.selected + 1)}
          containerClassName="pagination custom-pagination mt-md-0 mt-3 mb-0"
          subContainerClassName="pages"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          activeClassName="active"
          previousClassName="page-item"
          nextClassName="page-item"
          previousLinkClassName="page-link"
          nextLinkClassName="page-link"
          forcePage={pageMeta?.page ? parseInt(pageMeta?.page, 10) - 1 : 0}
        />
      ) : null}
    </div>
  );
}
